// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14OeD","label":"styles_label__3QgVs"};